import { PageName } from '../../store/ducks/settings/types';

export const useGetPage = (page: PageName) => {
  if (page === 'home') return window.location.pathname.includes('/w/');
  if (page === 'world') return window.location.pathname.includes('/cw/');
  return window.location.pathname.includes(`/${page}`);
};
